module.exports = __webpack_public_path__ + "static/media/RNG-banner.cac15527.png";